import { render, staticRenderFns } from "./ColorPicker.vue?vue&type=template&id=56cea29c&scoped=true&"
import script from "./ColorPicker.vue?vue&type=script&lang=js&"
export * from "./ColorPicker.vue?vue&type=script&lang=js&"
import style0 from "./ColorPicker.vue?vue&type=style&index=0&id=56cea29c&lang=scss&scoped=true&"
import style1 from "./ColorPicker.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cea29c",
  null
  
)

export default component.exports